import React, { useEffect, useMemo, useState } from 'react';
import { Button } from 'tea-component';
import { useIntl } from 'umi';
import { AddLevelUpGameCompare } from '@op/pages/competitor/components/ComparisonCard/Components/AddCompare';
import { LevelUpGameSelectionType } from '../../types';
import { commonBackInfo } from '../../utils';
import { buriedBtnPoint } from '@op/operationLog/buriedPoint';
import './index.scss';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';

export default function LevelUpGameSelectionSelect({
  gameInfo,
  wholeGameInfo,
  filterOptions,
  onChange,
  changeOnCloseWindow,
  defaultValue,
  filterValue,
  params,
}: LevelUpGameSelectionType) {
  const { formatMessage } = useIntl();

  const [visible, setVisible] = useState(false);
  const [selectGameList, setSelectGameList] = useState<Array<any>>([]);

  useEffect(() => {
    const data = selectGameList
      .map((item) => {
        if (item?.edition_unified_id) {
          return {
            edition_unified_id: item?.edition_unified_id,
            entity_type: item?.entity_type,
            id_type: item?.id_type,
          };
        }
      })
      .filter(Boolean);

    if (data.length > 0) {
      data.push(gameInfo);
    }

    onChange?.(
      'levelUpGame',
      commonBackInfo({ selected_games: data }, { levelUpGame: null }),
    );
  }, [selectGameList]);

  useEffect(() => {
    if (filterValue?.selected_games) {
      setSelectGameList(filterValue?.selected_games);
    }
  }, [filterValue]);

  const { textElement, diffClassName } = useMemo(() => {
    const list = selectGameList.filter((item) => item?.edition_unified_id);

    if (list.length === 0)
      return {
        textElement: formatMessage({ id: 'All' }),
        diffClassName: '',
      };

    return {
      textElement: list.length,
      diffClassName: 'dbo-diff-filter',
    };
  }, [selectGameList, formatMessage]);

  return (
    <div className={`level-up-game-select-wrapper ${diffClassName}`}>
      <Button
        type="weak"
        className="dbo-select-btn"
        onClick={() => {
          setVisible(true);
          buriedBtnPoint('SelectGame');
        }}
      >
        <div className="dbo-select-title">{formatMessage({ id: 'Game' })}</div>
        {textElement}
      </Button>

      {visible && (
        <AddLevelUpGameCompare
          mainGame={wholeGameInfo}
          visible={visible}
          selected={selectGameList}
          params={params}
          close={() => setVisible(false)}
          confirm={(targetList: any[]) => {
            buriedBtnPoint(
              FilterButtonPoint.levelUpGame,
              targetList?.map((item) => ({
                edition_unified_id: item?.edition_unified_id,
                entity_type: item?.entity_type,
                id_type: item?.id_type,
              })),
            );
            setSelectGameList(targetList);
          }}
        />
      )}
    </div>
  );
}
